<mat-card-header>
  <mat-card-title>Seats won</mat-card-title>
</mat-card-header>
<mat-card-content>
  <div class="graph">
    <table class="card-container">
      <tr>
        <td>

        </td>
        <td>
          <div #tooltip5="matTooltip" [matTooltip]="hemicycleTooltips[5]" matTooltipClass="mat-toolTip" (click)="tooltip5.show()" class="lcDot" [style.background-color]="hemicycleDots[5]"></div>
        </td>
        <td>
          <div #tooltip6="matTooltip" [matTooltip]="hemicycleTooltips[6]" matTooltipClass="mat-toolTip" (click)="tooltip6.show()" class="lcDot" [style.background-color]="hemicycleDots[6]"></div>
        </td>
        <td>
          <div #tooltip7="matTooltip" [matTooltip]="hemicycleTooltips[7]" matTooltipClass="mat-toolTip" (click)="tooltip7.show()" class="lcDot" [style.background-color]="hemicycleDots[7]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip4="matTooltip" [matTooltip]="hemicycleTooltips[4]" matTooltipClass="mat-toolTip" (click)="tooltip4.show()" class="lcDot" [style.background-color]="hemicycleDots[4]"></div>
        </td>
        <td colspan="5" align="center" class="info">

        </td>
        <td>
          <div #tooltip8="matTooltip" [matTooltip]="hemicycleTooltips[8]" matTooltipClass="mat-toolTip" (click)="tooltip8.show()" class="lcDot" [style.background-color]="hemicycleDots[8]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip3="matTooltip" [matTooltip]="hemicycleTooltips[3]" matTooltipClass="mat-toolTip" (click)="tooltip3.show()" class="lcDot" [style.background-color]="hemicycleDots[3]"></div>
        </td>
        <td colspan="5" align="center" class="info">

        </td>
        <td>
          <div #tooltip9="matTooltip" [matTooltip]="hemicycleTooltips[9]" matTooltipClass="mat-toolTip" (click)="tooltip9.show()" class="lcDot" [style.background-color]="hemicycleDots[9]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip2="matTooltip" [matTooltip]="hemicycleTooltips[2]" matTooltipClass="mat-toolTip" (click)="tooltip2.show()" class="lcDot" [style.background-color]="hemicycleDots[2]"></div>
        </td>

        <td colspan="5" align="center" class="info">

        </td>
        <td>
          <div #tooltip10="matTooltip" [matTooltip]="hemicycleTooltips[10]" matTooltipClass="mat-toolTip" (click)="tooltip10.show()" class="lcDot" [style.background-color]="hemicycleDots[10]"></div>
        </td>
      </tr>
      <tr>
        <td>
          <div #tooltip1="matTooltip" [matTooltip]="hemicycleTooltips[1]" matTooltipClass="mat-toolTip" (click)="tooltip1.show()" class="lcDot" [style.background-color]="hemicycleDots[1]"></div>
        </td>
        <td colspan="5" align="center" class="info">

        </td>

        <td>
          <div #tooltip11="matTooltip" [matTooltip]="hemicycleTooltips[11]" matTooltipClass="mat-toolTip" (click)="tooltip11.show()" class="lcDot" [style.background-color]="hemicycleDots[11]"></div>
        </td>
      </tr>
    </table>
  </div>
</mat-card-content>
